import _ from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { customFetch, CustomFetchState } from '../utils/helpers'

const useFetch = (url: RequestInfo, options: RequestInit = {}, deps: React.DependencyList = []): CustomFetchState => {
  const [state, setState] = useState({ loading: false, error: null, data: null })
  const onUpdate = useCallback((newState: CustomFetchState) => setState({ ...state, ...newState }), [])
  useEffect(
    () => {
      const { cancel } = customFetch(url, options, onUpdate)
      return () => cancel()
    },
    [url, options, ...deps]
  )
  return state
}

export default useFetch
